<template>
  <div class="dates">
    <div class="top-text">
      <h2 class="bold">Take note of these important dates to start off your MISA Journey!</h2>
      <h4>Click through the timeline below to see and figure out how your path with us will start.</h4>
    </div>
    <div class="breadcrumbs">
      <div class="crumb" >
        <h5>January 18</h5>
        <button class="tabline circle" v-on:click="openTab($event, 'june-27', 'none')" id="default-open"></button>
      </div>

      <div class="crumb hidden-text" >
        <h5>.</h5>
        <img class="right" src='~@/assets/right.png' id="ab1">
        <img class="right2" src='~@/assets/right2.png' id="at1">
      </div>

      <div class="crumb">
        <h5>January 18</h5>
        <button class="tabline circle" v-on:click="openTab($event, 'june-30', 'ab1')"></button>
      </div>

      <div class="crumb hidden-text" >
        <h5>.</h5>
        <img class="right" src='~@/assets/right.png' id="ab2">
        <img class="right2" src='~@/assets/right2.png' id="at2">
      </div>

      <div class="crumb">
        <h5>January 22</h5>
        <button class="tabline circle" v-on:click="openTab($event, 'july-4', 'ab2')"></button>
      </div>

      <div class="crumb hidden-text" >
        <h5>.</h5>
        <img class="right" src='~@/assets/right.png' id="ab3">
        <img class="right2" src='~@/assets/right2.png' id="at3">
      </div>

      <div class="crumb">
        <h5>January 25</h5>
        <button class="tabline circle" v-on:click="openTab($event, 'july-10', 'ab3')"></button>
      </div>

      <div class="crumb hidden-text" >
        <h5>.</h5>
        <img class="right" src='~@/assets/right.png' id="ab4">
        <img class="right2" src='~@/assets/right2.png' id="at4">
      </div>

      <div class="crumb last">
        <h5> .</h5>
          <button class=" tabline hexagons" v-on:click="openTab($event, 'last', 'ab4')"></button>
      </div>
    </div>
    <!-- <div class="lines">
      <div class="line"></div>
      <div class="line"></div>
      <div class="line"></div>
      <div class="linelast"></div>
    </div> -->
    <div class="info-hover">
      <div id="june-27" class="tabcontent">
        <h2>Applications Open</h2>
        <h3>Read through our primers, find out which cluster is calling out to you, apply, and join our family!</h3>
      </div>

      <div id="june-30" class="tabcontent">
        <h2>Individual Cluster Process</h2>
        <h3>During this period, we will be informing all applicants about the succeeding steps of their application.</h3>
      </div>

      <div id="july-4" class="tabcontent">
        <h2>Applications Deadline</h2>
        <h3>This is the last day of applications! Don’t forget to send in your applications to be a part of the family!</h3>
      </div>

      <div id="july-10" class="tabcontent">
        <h2>MISA Officers Announcement</h2>
        <h3>Make sure to check out our social media pages on this day, as we will be announcing the official officers for the upcoming academic year!</h3>
      </div>

      <div id="last" class="tabcontent">
        <h2>Third batch of MISA Officers for A.Y. 2020-2021 is finally complete!</h2>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Dates',
  components: {

  },
  methods: {
    openTab: function (evt,date, arw) {
      // Declare all variables
      var i, tabcontent, tablinks;

      // Get all elements with class="tabcontent" and hide them
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
          tabcontent[i].style.display = "none";
      }

      // arrow = document.getElementsByClassName("right");
      // for (i = 0; i < arrow.length; i++) {
      //     arrow[i].style.display = "block";
      // }

      // arrow2 = document.getElementsByClassName("right2");
      // for (i = 0; i < arrow2.length; i++) {
      //     arrow2[i].style.display = "none";
      // }

      switch(arw){
        case 'none': 
          document.getElementById('ab1').style.display = "block"; 
          document.getElementById('ab2').style.display = "block"; 
          document.getElementById('ab3').style.display = "block"; 
          document.getElementById('ab4').style.display = "block"; 
          document.getElementById('at1').style.display = "none"; 
          document.getElementById('at2').style.display = "none";
          document.getElementById('at3').style.display = "none";
          document.getElementById('at4').style.display = "none";
          break;
        case 'ab1': 
          document.getElementById('ab1').style.display = "none"; 
          document.getElementById('ab2').style.display = "block"; 
          document.getElementById('ab3').style.display = "block"; 
          document.getElementById('ab4').style.display = "block"; 
          document.getElementById('at1').style.display = "block"; 
          document.getElementById('at2').style.display = "none";
          document.getElementById('at3').style.display = "none";
          document.getElementById('at4').style.display = "none";
          break;
        case 'ab2': 
          document.getElementById('ab1').style.display = "none"; 
          document.getElementById('ab2').style.display = "none"; 
          document.getElementById('ab3').style.display = "block"; 
          document.getElementById('ab4').style.display = "block"; 
          document.getElementById('at1').style.display = "block"; 
          document.getElementById('at2').style.display = "block";
          document.getElementById('at3').style.display = "none";
          document.getElementById('at4').style.display = "none";
          break;  
        case 'ab3': 
          document.getElementById('ab1').style.display = "none"; 
          document.getElementById('ab2').style.display = "none"; 
          document.getElementById('ab3').style.display = "none"; 
          document.getElementById('ab4').style.display = "block"; 
          document.getElementById('at1').style.display = "block"; 
          document.getElementById('at2').style.display = "block";
          document.getElementById('at3').style.display = "block";
          document.getElementById('at4').style.display = "none";
          break;  
        case 'ab4': 
          document.getElementById('ab1').style.display = "none"; 
          document.getElementById('ab2').style.display = "none"; 
          document.getElementById('ab3').style.display = "none"; 
          document.getElementById('ab4').style.display = "none"; 
          document.getElementById('at1').style.display = "block"; 
          document.getElementById('at2').style.display = "block";
          document.getElementById('at3').style.display = "block";
          document.getElementById('at4').style.display = "block";
          break; 
      }


      // Get all elements with class="tablinks" and remove the class "active"
      tablinks = document.getElementsByClassName("tabline");
      for (i = 0; i < tablinks.length; i++) {
          tablinks[i].className = tablinks[i].className.replace(" active", "");
      }

      // Show the current tab, and add an "active" class to the button that opened the tab
      document.getElementById(date).style.display = "block";
      evt.currentTarget.className += " active";
    },
  },
  mounted() {
    document.getElementById("default-open").click();
  }
}
</script>

<style scoped>
    /* .dates{
        height: 80vh;
    } */
    .crumb .img{
    position: absolute;    
    background-image: 
    url('~@/assets/bwmisa.png');
    
    height:3.7vw;
    background-size: 3.5vw;
    background-repeat: no-repeat;
    margin: auto;
    min-width: 54px;
    min-height: 24px;
  }
  h3{
    font-weight: 600;
  }

  .lines{
    display: flex;
    flex-direction: row;
  }

  .line{
    width: 19vw;
    height: 4px;
    background-color: #242424;
    position: relative;
    left: 3vw;
    bottom: 4vh;
    z-index: -1;
  }

  .linelast{
    width: 12vw;
    height: 4px;
    background-color: #242424;
    position: relative;
    left: 3vw;
    bottom: 4vh;
    z-index: -1;
    display: block;
  }

  .tabcontent{
    display: none;
  }


  .circle{
    background: #FFFFFF;
    border: 3px solid #242424;
    box-sizing: border-box;

    border-radius: 50%;
    height: 2vw;
    width: 2vw;
    margin: auto;
    min-width: 24px;
    min-height: 24px;
  }



  .right{
    height: 1.2vw;
    width: 1.5vw;
    margin: auto;
    min-width: 12px;
    min-height: 12px;
    position: relative;
    top: 0.4vw;
    background-image: url('~@/assets/right.png');
    /* display: block; */
  }

  .right2{
    display: none;
    height: 1.2vw;
    width: 1.5vw;
    margin: auto;
    min-width: 12px;
    min-height: 12px;
    position: relative;
    top: 0.4vw;
  }

  .hexagons{
    border: none;
    height: 2.74vw;
    width: 2.64vw;
    background-color: white;
    background-image: url('~@/assets/darkgrey.svg');
    background-size: cover;
    min-width: 32px;
    min-height: 32px;
  }

  .last h5{
    color: white;
  }

  .hidden-text h5{
    color: white;
  }

  
  .circle.active{
    background: #31A5AF;
    border: 3px solid #31A5AF;
  }

  .hexagons.active{
    background-image: url('~@/assets/flatteal2.png');
  }

  .crumb{
    width: 130px;
    text-align: center;
    justify-items: center;
  }

  .breadcrumbs{
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
  }

  .top-text{
    /* padding-top: 40px; */
  }

  .info-hover{
    border: 2px solid #242424;
    box-sizing: border-box;
    border-radius: 10px;
    padding: 1em;

    margin: 4vh 0px;
  }

</style>

